<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :title="model.pkid ? '编辑' : '新建'"
      width="600px"
      @close="$reset('form')">
    <el-form 
        ref="form"
        v-loading="contentLoading" 
        :model="model" 
        :rules="ruleValidate" 
        class="form" 
        label-width="80px">
      <el-form-item label="编码" prop="toolTypeNo">
        <el-input v-model="model.toolTypeNo" placeholder="请输入菜单编码"/>
      </el-form-item>
      <el-form-item label="名称" prop="toolTypeName">
        <el-input v-model="model.toolTypeName" placeholder="请输入菜单名称"/>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button :loading="submitLoading" type="primary" @click="submitHandle">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
  export default {
    name: "ToolTypeEdit",
    data() {
      return {
        dialogVisible: false,
        submitLoading: false,
        contentLoading: false,
        model: {
          pkid: 0,
          toolTypeNo: "",
          toolTypeName: "",
          parentId: "",
        },
        ruleValidate: {
          toolTypeNo: { required: true, message: "请输入编号", trigger: "blur" },
          toolTypeName: { required: true, message: "请输入名称", trigger: "blur" },
        },
      };
    },
    methods: {
      open(row, mark) {
        this.dialogVisible = true;
        if (row) {
          if (mark) {
            this.getData(row.id);
          } else {
            this.model.parentId = row.id;
          }
        }
      },

      getData(id) {
        this.contentLoading = true;
        this.$http
          .get("basic", `toolTypes/${id}`)
          .then((resp) => {
            if (resp.success) {
              this.model = resp.data;
            }
            this.contentLoading = false;
          })
          .catch(() => {
            this.contentLoading = false;
          });
      },

      submitHandle() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.submitLoading = true;
            this.$http
              .save("basic", "toolTypes", this.model)
              .then((resp) => {
                this.submitLoading = false;
                if (resp.success) {
                  if (this.model.pkid) {
                    this.$emit("save-success");
                    this.$message.success("编辑成功");
                  } else {
                    this.$emit("save-success");
                    this.$message.success("添加成功");
                  }
                  this.dialogVisible = false;
                }
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
    },
  };
</script>
